import { generateUUID } from 'helpers/uuid';
import { NOTIFICATION_LEVELS, NOTIFICATION_LIFESPAN } from 'constants/application';
import store from 'state/configureStore';

export const NOTIFICATION_ACTIONS = {
  NOTIFICATION_ADDED: 'NOTIFICATION_ADDED',
  NOTIFICATION_REMOVED: 'NOTIFICATION_REMOVED',
  NOTIFICATIONS_CLEARED: 'NOTIFICATIONS_CLEARED',
};

/**
 * Dispatches an action to add a notification to the application store's
 * notigiections list
 * @param {string} message
 * @param {string} level
 */
export const addNotification = (
  message,
  level = NOTIFICATION_LEVELS.INFO,
  lifespan = NOTIFICATION_LIFESPAN,
) => {
  const id = generateUUID();
  store.dispatch({
    type: NOTIFICATION_ACTIONS.NOTIFICATION_ADDED,
    data: { id, message, level },
  });

  if (lifespan > 0) {
    setTimeout(() => {
      removeNotification(id);
    }, lifespan);
  }
};

/**
 * Dispatches an action to the application store signifying that the
 * notification is to be removed.
 * @param {string} id
 */
export const removeNotification = (id) => {
  store.dispatch({
    type: NOTIFICATION_ACTIONS.NOTIFICATION_REMOVED,
    data: { id },
  });
};

/**
 * Dispatches an action to the application store signifying that ALL
 * notifications are to be removed.
 */
export const clearAllNotifications = () => {
  store.dispatch({
    type: NOTIFICATION_ACTIONS.NOTIFICATIONS_CLEARED,
  });
};

// Sugar export of application/NOTIFICATION_LEVELS
export { NOTIFICATION_LEVELS };
